import type { SxProps, Theme } from '@mui/material/styles';
import MuiTooltip from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';
import { useMemo } from 'react';

const BG = '#18181b';

const tooltipBaseSx: SxProps<Theme> = {
    bgcolor: BG,
    color: '#fafafa',
    borderRadius: '6px',
    px: '10px',
    py: '5px',
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.4,
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
};

const arrowBaseSx: SxProps<Theme> = {
    color: BG,
};

// Stable slotProps reference so MuiTooltip skips slot-prop diffs in virtualized tables.
const DEFAULT_SLOT_PROPS = {
    tooltip: { sx: tooltipBaseSx },
    arrow: { sx: arrowBaseSx },
};

export const Tooltip = ({ slotProps, placement = 'bottom', ...rest }: TooltipProps) => {
    const mergedSlotProps = useMemo(() => {
        if (!slotProps) return DEFAULT_SLOT_PROPS;
        return {
            tooltip: {
                ...slotProps.tooltip,
                sx: [
                    tooltipBaseSx,
                    (slotProps.tooltip as { sx?: SxProps<Theme> })?.sx ?? null,
                ] as unknown as SxProps<Theme>,
            },
            arrow: {
                ...slotProps.arrow,
                sx: [
                    arrowBaseSx,
                    (slotProps.arrow as { sx?: SxProps<Theme> })?.sx ?? null,
                ] as unknown as SxProps<Theme>,
            },
        };
    }, [slotProps]);
    return <MuiTooltip arrow placement={placement} slotProps={mergedSlotProps} {...rest} />;
};
